/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_Not_ConnectedInputs */

const en_dropbox_not_connected = /** @type {(inputs: Dropbox_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Dropbox in Settings to import documents.`)
};

const es_dropbox_not_connected = /** @type {(inputs: Dropbox_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta Dropbox en Ajustes para importar documentos.`)
};

/**
* | output |
* | --- |
* | "Connect Dropbox in Settings to import documents." |
*
* @param {Dropbox_Not_ConnectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_not_connected = /** @type {((inputs?: Dropbox_Not_ConnectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_Not_ConnectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_not_connected(inputs)
	return en_dropbox_not_connected(inputs)
});